import { getPaginationRange } from "@/lib/getPaginationRange";
import styles from "./pagination.module.css";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { useTranslations } from "next-intl";

type Props = {
  total: number;
  pageSize: number;
  currentPage: number;
  onPageChange: (page: number) => void;
};

export function Pagination({
  total,
  pageSize,
  currentPage,
  onPageChange,
}: Props) {
  const pages = getPaginationRange(total, pageSize, currentPage);
  const t = useTranslations("Pagination");
  if (total === 0) return null;

  return (
    <div
      className={styles.paginationWrapper}
      role="navigation"
      aria-label={t("pagination")}
    >
      <button
        type="button"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className={styles.backButton}
        aria-label={t("previousPage")}
      >
        <MdKeyboardArrowLeft aria-hidden="true" />
      </button>

      {/* <div className={styles.pageNumbers}> */}
      {pages.map((page, index) =>
        typeof page === "number" ? (
          <button
            type="button"
            key={index}
            className={`${styles.button} ${
              page === currentPage ? styles.active : ""
            }`}
            onClick={() => onPageChange(page)}
            aria-current={page === currentPage ? "page" : undefined}
            aria-label={t("goToPage", { page })}
          >
            {page}
          </button>
        ) : (
          <span key={index} className={styles.dots} aria-hidden="true">
            ...
          </span>
        )
      )}
      {/* </div> */}

      <button
        type="button"
        disabled={currentPage === Math.ceil(total / pageSize)}
        onClick={() => onPageChange(currentPage + 1)}
        className={styles.nextButton}
        aria-label={t("nextPage")}
      >
        <MdKeyboardArrowRight aria-hidden="true" />
      </button>
    </div>
  );
}
